module.exports = __webpack_public_path__ + "media/images/icons/swiper_next-635f7ff9eb64e5d10a30d562566c19aa.svg";